import { render, staticRenderFns } from "./AggiuntaRigaGenerale.vue?vue&type=template&id=6203538e&scoped=true&"
import script from "./AggiuntaRigaGenerale.vue?vue&type=script&lang=js&"
export * from "./AggiuntaRigaGenerale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6203538e",
  null
  
)

export default component.exports